type Environment = 'development' | 'acceptance' | 'production';

interface Config {
  SORTING_STREET_URL: string;
  COMPANIES_URL: string;
  REQUEST_URL: string;
  ENTREPRENEURS_URL: string;
  APPOINTMENTS_URL: string;
  NOTIFICATION_URL: string;
  ACARD_SAVE_POINTS_AND_CHEQUES_URL: string;
  ACARD_TRANSFER_URL: string;
  ACARD_INFO_URL: string;
  ECOUNTER_INFO_URL: string;
  PRIVACY_URL: string;
  ANTWERPEN_BE_URL: string;
  EID_INFO_URL: string;
  METANAV_SCRIPT_URL: string;
  CHANGE_EMAIL_URL: string;
  SPORT_DEFINITION_ID: string;
}

const getEnv = (): Environment => {
  if (/^(.*)-o\.antwerpen\.be/i.test(window.location.origin)) {
    return 'development';
  }
  if (/^(.*)-a\.antwerpen\.be/i.test(window.location.origin)) {
    return 'acceptance';
  }
  if (/^(.*)\.antwerpen\.be/i.test(window.location.origin)) {
    return 'production';
  }

  return 'development';
};

const useConfig = () => {
  const config: Record<Environment, Config> = {
    development: {
      SORTING_STREET_URL: 'https://sorteerpasopladen-o.antwerpen.be',
      COMPANIES_URL: 'https://www.dev.dcs.antwerpen.be',
      REQUEST_URL: 'https://eloket-o.antwerpen.be/',
      ENTREPRENEURS_URL: 'https://eloket-o.antwerpen.be/nl/eloket/mijnloket/context/ondernemer',
      NOTIFICATION_URL: 'https://amap-o.antwerpen.be',
      APPOINTMENTS_URL: 'http://afspraken-o.antwerpen.be',
      ACARD_SAVE_POINTS_AND_CHEQUES_URL:
        'https://stadsplan.antwerpen.be/stadslagen/53ecbd13991b170005e936fc',
      ACARD_TRANSFER_URL: 'https://www.dev.dcs.antwerpen.be/nl/voorkeuren/akaart',
      ACARD_INFO_URL: 'https://www.antwerpen.be/a-kaart',
      ECOUNTER_INFO_URL: 'https://eloket-o.antwerpen.be/',
      PRIVACY_URL:
        'https://www.antwerpen.be/info/5310f241aaa8a74f6c8b458d/a-stad-uw-privacy-en-hoe-gebruiken',
      ANTWERPEN_BE_URL: 'https://www.dev.dcs.antwerpen.be/',
      EID_INFO_URL: 'https://www.antwerpen.be/info/5a1d59d5ca69bc18a152981b/digitale-sleutels',
      METANAV_SCRIPT_URL:
        'https://acpaasui.s3.amazonaws.com/mtn/metanav.version_4.0.0-alpha0.min.js',
      CHANGE_EMAIL_URL: 'https://www.antwerpen.be/info/het-e-mailadres-in-een-a-profiel-wijzigen',
      SPORT_DEFINITION_ID: '57a08eb2eaf6b797685471ff',
    },
    acceptance: {
      SORTING_STREET_URL: 'https://sorteerpasopladen-a.antwerpen.be',
      COMPANIES_URL: 'https://www.acc.dcs.antwerpen.be',
      REQUEST_URL: 'https://www.acc.dcs.antwerpen.be/producten',
      ENTREPRENEURS_URL: 'https://eloket-a.antwerpen.be/nl/eloket/mijnloket/context/ondernemer',
      NOTIFICATION_URL: 'https://meldingen.antwerpen.be/melden',
      APPOINTMENTS_URL: 'https://www.acc.dcs.antwerpen.be/producten',
      ACARD_SAVE_POINTS_AND_CHEQUES_URL:
        'https://stadsplan.antwerpen.be/stadslagen/53ecbd13991b170005e936fc',
      ACARD_TRANSFER_URL: 'https://www.acc.dcs.antwerpen.be/nl/voorkeuren/akaart',
      ACARD_INFO_URL: 'https://www.antwerpen.be/a-kaart',
      ECOUNTER_INFO_URL: 'https://eloket-a.antwerpen.be/',
      PRIVACY_URL:
        'https://www.antwerpen.be/info/5310f241aaa8a74f6c8b458d/a-stad-uw-privacy-en-hoe-gebruiken',
      ANTWERPEN_BE_URL: 'https://www.acc.dcs.antwerpen.be/',
      EID_INFO_URL: 'https://www.antwerpen.be/info/5a1d59d5ca69bc18a152981b/digitale-sleutels',
      METANAV_SCRIPT_URL:
        'https://acpaasui.s3.amazonaws.com/mtn/metanav.version_4.0.0-alpha0.min.js',
      CHANGE_EMAIL_URL: 'https://www.antwerpen.be/info/het-e-mailadres-in-een-a-profiel-wijzigen',
      SPORT_DEFINITION_ID: '57a08eb2eaf6b797685471ff',
    },
    production: {
      SORTING_STREET_URL: 'https://sorteerpasopladen.antwerpen.be',
      COMPANIES_URL: 'https://www.antwerpen.be',
      REQUEST_URL: 'https://www.antwerpen.be/producten',
      ENTREPRENEURS_URL: 'https://eloket.antwerpen.be/nl/eloket/mijnloket/context/ondernemer',
      NOTIFICATION_URL: 'https://meldingen.antwerpen.be/melden',
      APPOINTMENTS_URL: 'https://www.antwerpen.be/producten',
      ACARD_SAVE_POINTS_AND_CHEQUES_URL:
        'https://stadsplan.antwerpen.be/stadslagen/53ecbd13991b170005e936fc',
      ACARD_TRANSFER_URL: 'https://www.antwerpen.be/nl/voorkeuren/akaart',
      ACARD_INFO_URL: 'https://www.antwerpen.be/a-kaart',
      ECOUNTER_INFO_URL: 'https://eloket.antwerpen.be/',
      PRIVACY_URL:
        'https://www.antwerpen.be/info/5310f241aaa8a74f6c8b458d/a-stad-uw-privacy-en-hoe-gebruiken',
      ANTWERPEN_BE_URL: 'https://www.antwerpen.be/',
      EID_INFO_URL: 'https://www.antwerpen.be/info/5a1d59d5ca69bc18a152981b/digitale-sleutels',
      METANAV_SCRIPT_URL:
        'https://acpaasui.s3.amazonaws.com/mtn/metanav.version_4.0.0-alpha0.min.js',
      CHANGE_EMAIL_URL: 'https://www.antwerpen.be/info/het-e-mailadres-in-een-a-profiel-wijzigen',
      SPORT_DEFINITION_ID: '57a08eb2eaf6b797685471ff',
    },
  };

  return config[getEnv()];
};

export default useConfig;
